import { render, staticRenderFns } from "./Gln.vue?vue&type=template&id=2e6853e1&scoped=true"
import script from "./Gln.vue?vue&type=script&lang=js"
export * from "./Gln.vue?vue&type=script&lang=js"
import style0 from "./Gln.vue?vue&type=style&index=0&id=2e6853e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6853e1",
  null
  
)

export default component.exports